import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';

import { Translate } from '@core/constant';
import { useIdleTimer } from '@core/hook';
import { EButtonVariant, EColor, EIcon, ESize, ETypographyVariant } from '@core/type';

import { useContextCrisp } from '@crisp';

import { Button } from '../button';
import { Icon } from '../icon';
import { Box } from '../layout';
import { Link } from '../link';
import { Typography } from '../typography';
import { Modal } from './Modal';
import { ModalTakeABreakProps } from './interface-modal';

export const ModalTakeABreak = ({ openAfter }: ModalTakeABreakProps) => {
  const { openChat } = useContextCrisp();
  const { t } = useTranslation(Translate.page.SIGN_UP);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useIdleTimer(openAfter, () => setIsOpen(true));

  return (
    <Modal isOpen={isOpen} onCloseModal={() => setIsOpen(false)} size={ESize.LG}>
      <Modal.Header>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Icon
            type={EIcon.CLOCK}
            size={ESize.XL}
            marginBottom="8px"
            color={EColor.PRIMARY}
            secondColor={EColor.ACCENT}
          />
          <Typography variant={ETypographyVariant.H2}>{t('takeABreak.title')} </Typography>
        </Box>
      </Modal.Header>
      <Modal.Body>
        <Typography textAlign="center">{t('takeABreak.firstP')}</Typography>
        <Typography textAlign="center" marginBottom="8px">
          {t('takeABreak.noProblem')}
        </Typography>
        <Typography textAlign="center">
          {`${t('takeABreak.secondP')} `}
          <Link
            color={EColor.ACCENT}
            onClick={() => {
              setIsOpen(false);
              openChat();
            }}
          >
            {t('takeABreak.liveChat')}
          </Link>
          .
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Box display="flex" justifyContent="center">
          <Button onClick={() => setIsOpen(false)} type="button" variant={EButtonVariant.CONTAINED}>
            {t('takeABreak.resume')}
          </Button>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};
